import { collection, addDoc, getDocs, deleteDoc, doc, serverTimestamp, query, orderBy, limit } from "firebase/firestore";
import { useCollectionData } from "react-firebase-hooks/firestore";
import { firestore } from "hooks/useFirebase";
import { useFirebaseRef as useUserCalculatorFirebaseRef } from "../useUserCalculator/useUserCalculator";

export const useHistory = (userId) => {
  const userCalculatorRef = useUserCalculatorFirebaseRef(userId);
  const historyCollectionRef = userCalculatorRef
    ? collection(firestore, userCalculatorRef.path, "history")
    : null;
  
  const historyQuery = historyCollectionRef
    ? query(historyCollectionRef, orderBy("createdAt", "desc"), limit(12))
    : null;
  
  const [history, loading, error] = useCollectionData(
    historyQuery,
    { idField: "id" }
  );

  const add = (item) => {
    if (!historyCollectionRef) return Promise.reject(new Error("History collection reference is null"));
    
    return addDoc(historyCollectionRef, {
      ...item,
      createdAt: serverTimestamp(),
    }).catch((e) => console.dir(e));
  };

  const clear = async () => {
    if (!historyCollectionRef) return;
    
    try {
      const querySnapshot = await getDocs(historyCollectionRef);
      const deletePromises = querySnapshot.docs.map(snapshot => 
        deleteDoc(doc(firestore, historyCollectionRef.path, snapshot.id))
      );
      await Promise.all(deletePromises);
    } catch (error) {
      console.error("Error clearing history:", error);
    }
  };

  return { history, loading, error, add, clear };
};
